import React from 'react'
import Head from 'next/head';
import Image from "next/image";
import styles from "../tnpsc-admissions/tnpsc-admissions.module.css";

import upscbanner1 from "../../assets/images/home/Mob_Banner/Tnpsc-Achivers-Web-Banner.jpg";
import upscbanner2 from "../../assets/images/home/Mob_Banner/Banner.png";
import AOS from "aos";
import "aos/dist/aos.css";
import NPFform from"../../components/NPFForm/npfform"
import CountUp from "react-countup";
import Success from "../../assets/images/home/newicon/Success.jpg";
import Target1 from "../../assets/images/home/newicon/target.jpg";
import Faculty from "../../assets/images/home/newicon/Faculty.jpg";
import TestSeries from "../../assets/images/home/newicon/Testseries.jpg";
import redrightarrow from  "../../assets/images/contact/Rarrow.png";
import Whychoose from "../../components/why-tnpsc/index";
import Carousel from 'react-bootstrap/Carousel';

import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Interest from '../../components/might-be-interest';
import Syllabus from '../tnpsc/pre-syllabus';
import Pattern from '../tnpsc/pre-pattern';
import Exam from "../tnpsc/pre-exam";
import TNPSC_course from "../tnpsc-admissions/course-detials";
import Link from "next/link";
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { useRouter } from "next/router";

const BranchAddress = dynamic(()=>import("../../components/branch-address"),{ ssr: false });
const About_TNPSC = () => {

  const banners = [
            { img: upscbanner1, alt: "UPSC Anna Nagar", link: "/upsc-admission-anna-nagar"},
            { img: upscbanner2, alt: "UPSC Anna Nagar", link: "/upsc-admission-anna-nagar"},
        
      ]
    
    const stats1 = [
            { value: 2000, suffix: "+", label: "Group I, II and IV services from our Institute", delay: 100 },
            { value: 47, label: "out of 90 Vacancies  | TNPSC Group I 2024", delay: 200 },
            { value: 450, suffix: "+", label: " out of 1338 Vacancies | TNPSC Group II 2019", delay: 300 },
          ];

  const jsonLd ={
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Salem TNPSC Academy | Shankar IAS Academy",
    "url": "https://www.shankariasacademy.com/tnpsc-salem/",
    "Image":
    "https://www.shankariasacademy.com/_next/static/media/TNPSC-Gr-I-II-Prelims-Coaching-Web-banner.b884fefb.webp",
    "description": "Succeed in TNPSC exams with Salem TNPSC Academy. Expert coaching, comprehensive preparation. Enroll now for a successful TNPSC journey ahead!"
  }
   const router = useRouter();
     
     useEffect(() => {
       AOS.init({
         duration: 800,
         easing: "ease-in-out",
         once: true,
         offset: 100,
       });
     }, []);
     
     useEffect(() => {
       const handleRouteChange = () => {
         AOS.refresh();
       };
     
       router.events.on("routeChangeComplete", handleRouteChange);
     
       return () => {
         router.events.off("routeChangeComplete", handleRouteChange);
       };
     }, [router.events]);

  return (
    <>

        <Head>
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>Salem TNPSC Academy | Shankar IAS Academy</title>
            <meta name="title" content="Salem TNPSC Academy | Shankar IAS Academy" />
            <meta name="description" content="Succeed in TNPSC exams with Salem TNPSC Academy. Expert coaching, comprehensive preparation. Enroll now for a successful TNPSC journey ahead!" />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-salem/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Salem TNPSC Academy | Shankar IAS Academy" />
            <meta property="og:description" content="Succeed in TNPSC exams with Salem TNPSC Academy. Expert coaching, comprehensive preparation. Enroll now for a successful TNPSC journey ahead!" />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-salem/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
            {/* <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script> */}
        </Head>

      <Navbar title="tnpsc" />
      
      <div className="container">
          <div className="row">
            <div className="col-md-6">
                  <div data-aos="fade-right" className= {`${styles.cardBox} d-flex flex-wrap gap-3 p-4`}>
                    <h1>UPSC Civil Services Admission Open - 2026</h1>

                      <Link href="/tnpsc-admissions" className= {`${styles.branchBtn} `}>
                        Anna Nagar
                      </Link>

                      <Link href="/tnpsc-adyar" className={`${styles.branchBtn}`}>
                        Adyar
                      </Link>

                      <Link href="/tnpsc-coimbatore" className={`${styles.branchBtn} `}>
                        Coimbatore
                      </Link>

                      <Link href="/tnpsc-trichy" className={`${styles.branchBtn} `}>
                        Trichy
                      </Link>

                      <Link href="/tnpsc-salem" className={`${styles.branchBtn} `}>
                        Salem
                      </Link>

                      <Link href="/tnpsc-madurai" className={`${styles.branchBtn} `}>
                        Madurai
                      </Link>

                      <Link href="/tnpsc-namakkal" className={`${styles.branchBtn} `}>
                       Namakkal
                      </Link>

                      <Link href="/tnpsc-thiruvarur" className={`${styles.branchBtn} `}>              
                       Thiruvarur
                      </Link>
                  </div>

                  <div data-aos="fade-left" className={`${styles.bestbg1}`}>

                   <h1> TNPSC Course Overview</h1>


                   <div  className= " d-flex flex-wrap gap-3 p-4">
                       <Link href="#gspcm" className= {`${styles.courseBtn} `}>
                       Course Details
                      </Link>

                      <Link href="/tnpsc-group-i-mains-test-series" className={`${styles.courseBtn}`}>
                       Test Series
                      </Link>

                      <Link href="/our-achievers" className={`${styles.courseBtn} `}>
                        Topper List
                      </Link>

                      <Link href="#examcriteria" className={`${styles.courseBtn} `}>
                         Exam Criteria
                      </Link>

                      <Link href="#tnpsccentres" className={`${styles.courseBtn} `}>
                         Our Centres 
                      </Link>

                      <Link href="/tnpsc-demo-class-video" className={`${styles.branchBtnnew} `}>
                       TNPSC Demo Classes
                      </Link>

                    {/*   <div className={`${styles.brochure} justify-content-center`}>
                        <a href="https://www.shankariasacademy.com/pdf/UPSC-2026/Brochure-Chennai-Admission-2026.pdf" target="_blank" rel="noopener noreferrer">
                          <button className={`${styles.normalbutton1} btn btn-danger`}>
                            <Image src={downloadicon} alt="download icon" /> UPSC GSPCM 2026 (Brochure)
                          </button>
                        </a>
                      </div> */}
                    </div>
                  </div>
            </div>
            <div className="col-md-6 pt-3">
                  <Carousel>
                    {banners.map((e, index) =>
                      <Carousel.Item key={index}>
                        <Link href={e.link} rel="noreferrer">
                          <Image
                          className="carouselimage w-100 h-100"
                          src={e.img}
                          alt={e.alt}
                          title="Shankar IAS Academy"
                          /> 
                        </Link>
                      </Carousel.Item>
                    )}
                  </Carousel>
            </div>
          </div>
      </div>

     {/*<TNPSC_form /> */}

      <section className="container-fluid"  style={{
          background: "linear-gradient(to top, rgba(255, 242, 242, 0.8), rgb(182, 238, 255 , 29%))",
          opacity: "1",
        }}>
        <div className="container">
          <div className= "row mt-4 mb-2 ">
            <div className={`${styles.admincontent} col-12 col-md-6 pt-4 mt-4`}>
              <div className={styles.heroCard} data-aos="fade-right">
                <span className={styles.badge}>Tamilnadu Trusted TNPSC Coaching</span>
                <h1 className={styles.title}>
                  Best TNPSC Coaching in Tamilnadu
                  <span> Shankar IAS Academy Chennai</span>
                </h1>
                <p className={styles.description}>
                Shankar IAS Academy is a leading TNPSC coaching institute in Tamil Nadu, offering expert guidance for Group 1, Group 2, Group 2A, and Group 4 exams with comprehensive test series, updated materials, and consistent top results.
                </p>
                {/* Stats */}
                <div className={styles.statsRow}>
                  {stats1.map((item, index) => (
                    <div
                      key={index}
                      className={styles.statCircle}
                      data-aos="zoom-in"
                      data-aos-delay={item.delay}
                    >
                      <span className={styles.circleGlow}></span>
                      <h3>
                        <CountUp
                          end={item.value}
                          duration={6.5}
                          suffix={item.suffix || ""}
                        />
                      </h3>
                      <p>{item.label}</p>
                    </div>
                  ))}
                </div>
                {/* Features */}
                <div className={`${styles.featureGrid} pt-3`}>

                  <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="400">
                  <span><Image src={Success} width="36" height="36" alt="New_icon" className="img-fluid mx-2" /></span>  High Success Rate 
                  </div>

                  <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="500">
                    <span><Image src={Target1} width="46" height="4 6" alt="New_icon" className="img-fluid mx-2" /></span> Prelims & Mains Integrated Coaching
                  </div>

                  <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="600">
                      <span><Image src={Faculty} width="46" height="46" alt="New_icon" className="img-fluid mx-2" /></span>Expert Faculty & Mentorship
                  </div>

                  <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="700">
                    <span><Image src={TestSeries} width="36" height="36" alt="New_icon" className="img-fluid mx-2" /></span>Advanced Test Series
                  </div>

                </div>

                <div  className={`${styles.newachievernumber1} text-end pt-4 d-none d-md-block`} data-aos="fade-up" data-aos-delay="400">
                  <Link href="#" className={`${styles.acheivermore}`} id=""  onclick="fbq('track', 'ButtonClick');">
                    <span style={{ color: "rgb(66, 60, 60)", fontWeight:"bold", fontSize:"16px" }}>& More</span> <Image src={redrightarrow} className={`${styles.logoimg} img-fluid`} alt="Chennai Icon" width={20} height={20} />
                  </Link>
                </div>
              </div>
            </div>
            <div class="col-12  col-md-6 mt-4 mb-2">
              <p className={`${styles.contactheader} text-center`}>Enquiry Form</p>
              <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
              {/* <div class={`${styles.addmissionform} npf_wgts pt-4`} data-height="600px"   data-w="3f4274baec4df825dd72c5ff92d085ff"> </div>  */}
              <NPFform
                  formId="3f4274baec4df825dd72c5ff92d085ff"
                  height="600px"
                  className="myForm"
                />
            </div>
          </div>
        </div>
      </section>


      <TNPSC_course />

      <div className="container-fluid" style={{background: "linear-gradient(135deg, #ffffff, #ffe5e5)"}}>
        <Whychoose/>
      </div>

      <div className='container'>
        <div className='row pt-3'>
          <div className='col'>
            <Pattern />
          </div>
        </div>
      </div>

      <div className='container'>
        <div className='row pt-4'>
          <div className='col'>
            <Syllabus />
          </div>
        </div>
      </div>

      <div className='container-fluid' style={{ backgroundColor: "#F4F6F8" }}>
        <div className='row pt-4'>
          <div className='col'>
            <Exam />
          </div>
        </div>
      </div>


      <BranchAddress />
      <Interest />
      <Footer />
    </>
  )
}

export default About_TNPSC;